import { notify } from '@rezi/utils/toast';
import React, { useState } from 'react';
import clsx from 'clsx';
import { Icon } from '@rezi/ui/icon';

type CopyToClipboardProps = {
  textToCopy: string;
  className?: string;
  duotoneIcon?: boolean;
  onSuccessfulCopy?: () => void;
  tooltipText?: string;
  tooltipDirection?: 'top' | 'right' | 'bottom' | 'left';
};

export const CopyToClipboard = (props: CopyToClipboardProps) => {
  const {
    textToCopy,
    onSuccessfulCopy,
    className,
    duotoneIcon,
    tooltipText,
    tooltipDirection,
  } = props;
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      if (onSuccessfulCopy) {
        onSuccessfulCopy();
      } else {
        notify('Copied to clipboard', 'success');
      }
    } catch (err) {
      notify(`Failed to copy to clipboard: ${textToCopy}`, 'error');
    }
  };

  const [iconHover, setIconHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setIconHover(true)}
      onMouseLeave={() => setIconHover(false)}
    >
      <Icon
        size="small"
        icon={duotoneIcon ? 'fa-duotone fa-copy' : 'fa fa-solid fa-copy'}
        onClick={handleCopy}
        className={clsx(
          'cursor-pointer text-xl text-gray-900!',
          iconHover ? 'text-primary-500!' : 'text-gray-900!',
          className,
        )}
        type={'static'}
        tooltip={tooltipText}
        tooltipDirection={tooltipDirection}
      />
    </div>
  );
};
